import { render, staticRenderFns } from "./current.vue?vue&type=template&id=653cda48&scoped=true"
import script from "./current.vue?vue&type=script&lang=js"
export * from "./current.vue?vue&type=script&lang=js"
import style0 from "./current.vue?vue&type=style&index=0&id=653cda48&prod&lang=scss&scoped=true"
import style1 from "./current.vue?vue&type=style&index=1&id=653cda48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653cda48",
  null
  
)

export default component.exports